<div class="nav-content">
  <app-breadcrumbs />

  <app-mind-rec />

  <ng-container *transloco="let t">
    <div class="user-menu-wrapper">
      <div class="server-time" [matTooltip]="t('shared.serverTime')">
        {{ serverUtcTime() | addDeltaToTimeInZone: 0 : 'HH:mm:ss z' }}</div
      >

      <button class="account-button" mat-icon-button type="button" [matMenuTriggerFor]="accountMenu">
        <mat-icon svgIcon="account-circle-outline" />
      </button>

      <mat-menu #accountMenu="matMenu" overlapTrigger="false" xPosition="before">
        <button mat-menu-item type="button" (click)="openProfile()">
          <mat-icon svgIcon="account-circle-outline" />
          <span>{{ userName() }}</span>
        </button>

        <mat-divider />

        <button mat-menu-item type="button" (click)="signOut()">
          <mat-icon svgIcon="logout" />
          <span>{{ t('auth.signOut') }}</span>
        </button>
      </mat-menu>
    </div>
  </ng-container>
</div>
